import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule, MatIconModule, MatMenuModule, MatPaginatorModule, MatProgressSpinnerModule, MatSlideToggleModule, MatTableModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { FcCustomSelectModule } from '@core/components/fc-custom-select/fc-custom-select.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { CompanyQueries } from 'app/main/settings/accounts/companies/services/company.queries';
import { CompanyRankingComponent } from './company-ranking.component';
import { DialogConfirmDeleteCriteriasGroupComponent } from './components/dialogs/dialog-confirm-delete-criterias-group/dialog-confirm-delete-criterias-group.component';
import { DialogEditCriteriasGroupComponent } from './components/dialogs/dialog-edit-criterias-group/dialog-edit-criterias-group.component';
import { DialogEditCriteriasGroupModule } from './components/dialogs/dialog-edit-criterias-group/dialog-edit-criterias-group.module';
import { FilterModule } from './components/filter/filter.module';
import { CompanyRankingMapperService } from './services/company-raking.mapper.service';
import { CompanyRankingService } from './services/company-ranking.service';
import { FilterStateManagerService } from './services/filter-sate-manager.service';
import { TableCalculationsUtils } from './utils/table-calculations.utils';

const routes: Routes = [
  {
    path: 'relatorios/classificacao-empresas',
    component: CompanyRankingComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'COMPANY_RANKING.TITLE' }
  }
];

@NgModule({
  declarations: [
    CompanyRankingComponent,
    DialogConfirmDeleteCriteriasGroupComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    PipesModule,

    MatSlideToggleModule,
    MatTooltipModule,
    MatIconModule,
    MatMenuModule,
    MatTableModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,

    FcCustomSelectModule,

    FilterModule,
    DialogEditCriteriasGroupModule,
  ],
  providers: [
    CompanyQueries,
    CompanyRankingService,
    TableCalculationsUtils,
    FilterStateManagerService,
    CompanyRankingMapperService
  ],
  entryComponents: [
    DialogEditCriteriasGroupComponent
  ]
})
export class CompanyRankingModule { }
